const e = "styles-module__mobileMenuWrapper___kQfHk", n = "styles-module__mobileMenuContainer___C4TrJ", o = "styles-module__menuIconContainer___AgnAZ", _ = "styles-module__iconWrapper___nnWjY", s = "styles-module__logoContainer___oxG02", t = "styles-module__menuIcon___L9ZsM", l = "styles-module__defaultIcon___2Mn1p", u = "styles-module__hidden___uB9-J", a = "styles-module__activeIcon___KUi50", i = "styles-module__logo___zZoOh", m = "styles-module__menuModalOverlay___VK5ep", r = "styles-module__menuModalContent___cN1Y3", c = "styles-module__mobileBGIcon___oNeyB", d = "styles-module__menuModalOverlayOpen___j0Yie", y = "styles-module__menuLinksContainer___pFhdD", p = "styles-module__subCategories___bEJeu", C = "styles-module__mainMenuLink___95CkA", k = "styles-module__requestLawyerLink___S9q6m", M = "styles-module__askQuestionLink___HVRLj", I = "styles-module__arrowIcon___FPhTi", g = "styles-module__subMenuLink___MpK-m", b = "styles-module__subMenuContainer___disY3", L = "styles-module__offsetDropdownItemRow___8wigK", f = "styles-module__messageIcon___qQUEh", h = "styles-module__sparkIcon___jgDVi", w = "styles-module__desktopMenuContainer___Ovbm4", O = "styles-module__floatingContainer___IzC6E", W = "styles-module__shrink___bkBlT", v = "styles-module__menuContentContainer___5ogcm", B = "styles-module__spacer___p9YIU", Q = "styles-module__menuHeightWrapper___WZfQS", q = {
  mobileMenuWrapper: e,
  mobileMenuContainer: n,
  menuIconContainer: o,
  iconWrapper: _,
  logoContainer: s,
  menuIcon: t,
  defaultIcon: l,
  hidden: u,
  activeIcon: a,
  logo: i,
  menuModalOverlay: m,
  menuModalContent: r,
  mobileBGIcon: c,
  menuModalOverlayOpen: d,
  menuLinksContainer: y,
  subCategories: p,
  mainMenuLink: C,
  requestLawyerLink: k,
  askQuestionLink: M,
  arrowIcon: I,
  subMenuLink: g,
  subMenuContainer: b,
  offsetDropdownItemRow: L,
  messageIcon: f,
  sparkIcon: h,
  desktopMenuContainer: w,
  floatingContainer: O,
  shrink: W,
  menuContentContainer: v,
  spacer: B,
  menuHeightWrapper: Q
};
export {
  a as activeIcon,
  I as arrowIcon,
  M as askQuestionLink,
  q as default,
  l as defaultIcon,
  w as desktopMenuContainer,
  O as floatingContainer,
  u as hidden,
  _ as iconWrapper,
  i as logo,
  s as logoContainer,
  C as mainMenuLink,
  v as menuContentContainer,
  Q as menuHeightWrapper,
  t as menuIcon,
  o as menuIconContainer,
  y as menuLinksContainer,
  r as menuModalContent,
  m as menuModalOverlay,
  d as menuModalOverlayOpen,
  f as messageIcon,
  c as mobileBGIcon,
  n as mobileMenuContainer,
  e as mobileMenuWrapper,
  L as offsetDropdownItemRow,
  k as requestLawyerLink,
  W as shrink,
  B as spacer,
  h as sparkIcon,
  p as subCategories,
  b as subMenuContainer,
  g as subMenuLink
};
